var _g, _g2, _g3, _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifybg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2210,
    viewBox: "0 0 1440 2210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter0_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -77.2562,
    cy: 1714.5,
    rx: 178.592,
    ry: 202.684,
    transform: "rotate(-88.0167 -77.2562 1714.5)",
    fill: "url(#paint0_linear_2017_275)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter1_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1391.74,
    cy: 1178.5,
    rx: 178.592,
    ry: 202.684,
    transform: "rotate(-88.0167 1391.74 1178.5)",
    fill: "url(#paint1_linear_2017_275)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_275)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.503,
    cy: 273.335,
    rx: 210.503,
    ry: 197.074,
    fill: "#3C4B87"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.269,
    cy: 234.661,
    rx: 139.269,
    ry: 130.384,
    fill: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.269,
    cy: 220.684,
    rx: 139.269,
    ry: 130.384,
    fill: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.685,
    cy: 282.385,
    rx: 104.685,
    ry: 97.5692,
    fill: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 866.685,
    cy: 251.635,
    rx: 104.685,
    ry: 97.5692,
    fill: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 716,
    cy: 280.716,
    rx: 195,
    ry: 194.284,
    fill: "#5505FF",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 977,
    cy: 177.284,
    rx: 195,
    ry: 194.284,
    fill: "#5505FF",
    fillOpacity: 0.21
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2017_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911 272.33C911 379.63 823.696 466.614 716 466.614C608.304 466.614 521 379.63 521 272.33C521 165.03 608.304 78.0457 716 78.0457C823.696 78.0457 911 165.03 911 272.33Z",
    fill: "#3D1E66"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 712,
    cy: 297.954,
    rx: 130,
    ry: 86.659,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1022.5,
    cy: 238.784,
    rx: 145.5,
    ry: 144.898,
    fill: "#5505FF",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.819,
    cy: 242.116,
    rx: 139.269,
    ry: 130.384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2017_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 801,
    cy: 329.17,
    rx: 200,
    ry: 47.0568,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_2017_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.091 233.821L87 124.468L143.858 106.32C258.6 148.82 497.61 241.359 535.72 271.512C583.358 309.204 824.11 289.66 986.49 289.66C1116.39 289.66 1342.49 168.674 1439.31 108.182L1552 -10.4773C1544.15 66.1469 1446.17 236.333 1117.11 304.085C788.049 371.837 560.649 322.698 488.082 289.66L300.091 233.821Z",
    fill: "#3D1E66"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_2017_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.091 192.298L68 82.9454L124.858 64.7976C239.6 107.298 478.61 199.836 516.72 229.989C564.358 267.681 805.11 248.137 967.49 248.137C1097.39 248.137 1323.49 127.152 1420.31 66.6589L1533 -52C1525.15 24.6242 1427.17 194.811 1098.11 262.562C769.049 330.314 541.649 281.176 469.082 248.137L281.091 192.298Z",
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_dd_2017_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-96 -0.000366211C225.192 484.756 1208.23 491.233 1532 -0.000366211H-96Z",
    fill: "#070322"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96 -1C225.192 483.756 1208.23 490.233 1532 -1",
    stroke: "url(#paint2_linear_2017_275)",
    strokeWidth: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 658.75,
    y: 311.142,
    width: 118.5,
    height: 113.404,
    rx: 56.7022,
    fill: "url(#paint3_linear_2017_275)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 658.75,
    y: 311.142,
    width: 118.5,
    height: 113.404,
    rx: 56.7022,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M716.752 404.386C717.441 405.075 718.559 405.075 719.248 404.386L730.478 393.156C731.168 392.466 731.168 391.349 730.478 390.66C729.789 389.971 728.672 389.971 727.983 390.66L718 400.643L708.017 390.66C707.328 389.971 706.211 389.971 705.522 390.66C704.832 391.349 704.832 392.466 705.522 393.156L716.752 404.386ZM716.235 332.55V403.138H719.765V332.55H716.235Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2017_275",
    x: -596.515,
    y: 1219.27,
    width: 1038.52,
    height: 990.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 158.3,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2017_275",
    x: 872.485,
    y: 683.274,
    width: 1038.52,
    height: 990.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 158.3,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2017_275",
    x: 381.693,
    y: -51.0453,
    width: 675.62,
    height: 648.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.6534,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2017_275",
    x: 718.693,
    y: -23.0296,
    width: 533.151,
    height: 515.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.6534,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2017_275",
    x: 388.693,
    y: -37.0069,
    width: 533.151,
    height: 515.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.6534,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2017_275",
    x: 503.69,
    y: 73.5062,
    width: 431.991,
    height: 417.758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55.655,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2017_275",
    x: 634.693,
    y: 26.759,
    width: 463.984,
    height: 449.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.6534,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2017_275",
    x: 335.623,
    y: -98.9446,
    width: 760.753,
    height: 759.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.6883,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2017_275",
    x: 596.623,
    y: -202.377,
    width: 760.753,
    height: 759.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.6883,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2017_275",
    x: 335.623,
    y: -107.331,
    width: 760.753,
    height: 759.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.6883,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2017_275",
    x: 524,
    y: 153.295,
    width: 376,
    height: 289.318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2017_275",
    x: 691.623,
    y: -91.4904,
    width: 661.753,
    height: 660.549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.6883,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2017_275",
    x: 626.55,
    y: 63.7321,
    width: 374.538,
    height: 356.768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2017_275",
    x: 537,
    y: 218.113,
    width: 528,
    height: 222.114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2017_275",
    x: -29,
    y: -126.477,
    width: 1697,
    height: 580.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2017_275",
    x: -48,
    y: -168,
    width: 1697,
    height: 580.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58,
    result: "effect1_foregroundBlur_2017_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_dd_2017_275",
    x: -346,
    y: -360,
    width: 2128,
    height: 866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2017_275"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -110
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247894 0 0 0 0 0.00415364 0 0 0 0 0.934798 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2017_275",
    result: "effect2_dropShadow_2017_275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2017_275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2017_275",
    x1: -77.2562,
    y1: 1511.82,
    x2: -77.2562,
    y2: 1917.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2017_275",
    x1: 1391.74,
    y1: 975.816,
    x2: 1391.74,
    y2: 1381.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2017_275",
    x1: -50.5,
    y1: 182,
    x2: 1532,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855182,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905239,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2017_275",
    x1: 718,
    y1: 310.392,
    x2: 718,
    y2: 425.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8547F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDCBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 631,
    fill: "white",
    transform: "matrix(1 0 0 -1 -2 631)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifybg);
export default __webpack_public_path__ + "static/media/Verifybg.f78a4c56531e6e2a31331df5429aef41.svg";
export { ForwardRef as ReactComponent };